import React, {useContext} from "react"
import {NavigationLink} from "./navigation-link/navigation-link"
import styles from "./navigation-menu.module.scss"
import {useServices} from "../../services/services"
import {useHistory} from "react-router-dom"
import {UnauthenticatedUser, UserContext} from "../../services/authentication/user-context"
import {gaSendNavigationEvent} from "../../services/analytics/google-analytics-helper"

interface NavigationMenuProps {
  onNavigated: () => void
}

export const NavigationMenu: React.FC<NavigationMenuProps> = ({onNavigated}) => {
  const services = useServices()
  const history = useHistory()
  const user = useContext(UserContext)

  const clickLogout = () => {
    if (services === null) return

    services?.authenticationService.signOut()
    history.push("/")

    onNavigated()
  }

  const click = (eventLabel: string) => () => {
    gaSendNavigationEvent(eventLabel)
    onNavigated()
  }

  return (
    <div className={styles.NavigationMenu}>
      <NavigationLink to="/" onlyActiveWhenExactMatch materialIconName="home" onLinkClick={click("Home")}>Home</NavigationLink>
      <NavigationLink to="/privacy" materialIconName="security" onLinkClick={click("Privacy")}>Privacy</NavigationLink>
      {user !== UnauthenticatedUser
        ? <>
          <NavigationLink to="/dashboard" materialIconName="list_alt" onLinkClick={click("Dashboard")}>Dashboard</NavigationLink>
          <NavigationLink to="/climate-report" materialIconName="assignment" onLinkClick={click("Climate report")}>Klimaatrapport</NavigationLink>
          <NavigationLink to="/climate-advice" materialIconName="grading" onLinkClick={click("Climate advice")}>Klimaatadvies</NavigationLink>
          <NavigationLink to="#" materialIconName="logout" onLinkClick={clickLogout}>Uitloggen</NavigationLink>
        </>
        : <>
          <NavigationLink to="/signup" materialIconName="account_box" onLinkClick={click("Create account")}>Account maken</NavigationLink>
          <NavigationLink to="/login" materialIconName="login" onLinkClick={click("Sign in")}>Inloggen</NavigationLink>
        </>}
    </div>
  )
}